export enum DeviceType {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  nonMobile = 'non-mobile',
  nonTablet = 'non-tablet',
  nonDesktop = 'non-desktop',
}

export type DeviceViewportType = `${DeviceType}`
